declare namespace $ {

	type $shm_hitalama_guide_toggle__section_shm_hitalama_projects_1 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_guide_toggle['section'] >
	>
	type $mol_list__rows_shm_hitalama_projects_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_projects['projects_menu_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $shm_hitalama_projects_map__projects_shm_hitalama_projects_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_projects['self'] >
		,
		ReturnType< $shm_hitalama_projects_map['projects'] >
	>
	export class $shm_hitalama_projects extends $shm_projects_catalog {
		projects_menu_rows( ): readonly(any)[]
		self( ): $shm_hitalama_projects
		team( ): $shm_hitalama_team | null
		pinned_map( ): $shm_hitalama_map | null
		records_for_map( ): readonly($shm_projects_data_record)[]
		projects_map_id( next?: string ): string
		projects_map_ensure( ): string
		projects_link_open( next?: any ): any
		maps( ): $shm_hitalama_map_catalog
		Help( ): $shm_hitalama_guide_toggle
		Projects_menu( ): $mol_list
		Pinned_map_book( ): $shm_hitalama_map_book
		Map_slot( ): $shm_hitalama_projects_map
	}
	
}

//# sourceMappingURL=projects.view.tree.d.ts.map